<template>
  <div class="homepage-key-statistics-overview__wrapper">
    <homepage-key-statistics-main-block />

    <homepage-key-statistics-additional-blocks />
  </div>
</template>

<script>
import HomepageKeyStatisticsMainBlock from '@/components/_sections/_homepage/HomepageKeyStatistics/HomepageKeyStatisticsMainBlock/index.vue'
import HomepageKeyStatisticsAdditionalBlocks from '@/components/_sections/_homepage/HomepageKeyStatistics/HomepageKeyStatisticsAdditionalBlocks/index.vue'

export default {
  name: 'HomepageKeyStatisticsOverview',
  components: {
    HomepageKeyStatisticsAdditionalBlocks,
    HomepageKeyStatisticsMainBlock
  }
}
</script>

<style lang="scss" scoped>
.homepage-key-statistics-overview__wrapper {
  max-width: 1328px;

  $margin: (
    $above-desktop-xl: 64px auto 0,
    $mobile: 32px auto 0
  );

  @include setStyleByBreakpoint('margin', $margin);
}
</style>
